import React from "react";

const IconContainer = () => {
  return (
    <div
      style={{
        display: "flex",
        backgroundColor: "var(--colorNeutralBackground3)",
        width: "40px",
        height: "40px",
        flex: "0 0 auto",
        borderRadius: "4px",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <svg
        width="14"
        height="20"
        viewBox="0 0 14 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_2_13)">
          <path
            d="M3.33468 20C5.17468 20 6.66801 18.5067 6.66801 16.6667V13.3333H3.33468C1.49468 13.3333 0.00134277 14.8267 0.00134277 16.6667C0.00134277 18.5067 1.49468 20 3.33468 20Z"
            fill="#0ACF83"
          />
          <path
            d="M0.00134277 10C0.00134277 8.16 1.49468 6.66667 3.33468 6.66667H6.66801V13.3333H3.33468C1.49468 13.3333 0.00134277 11.84 0.00134277 10Z"
            fill="#A259FF"
          />
          <path
            d="M0.00134277 3.33333C0.00134277 1.49333 1.49468 0 3.33468 0H6.66801V6.66667H3.33468C1.49468 6.66667 0.00134277 5.17333 0.00134277 3.33333Z"
            fill="#F24E1E"
          />
          <path
            d="M6.66803 0H10.0014C11.8414 0 13.3347 1.49333 13.3347 3.33333C13.3347 5.17333 11.8414 6.66667 10.0014 6.66667H6.66803V0Z"
            fill="#FF7262"
          />
          <path
            d="M13.3347 10C13.3347 11.84 11.8414 13.3333 10.0014 13.3333C8.16136 13.3333 6.66803 11.84 6.66803 10C6.66803 8.16 8.16136 6.66667 10.0014 6.66667C11.8414 6.66667 13.3347 8.16 13.3347 10Z"
            fill="#1ABCFE"
          />
        </g>
        <defs>
          <clipPath id="clip0_2_13">
            <rect width="13.336" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default IconContainer;
